<template>
    <div class="form-group col-12">
        <label for="patient-tags">
            Tags
            <a
                tabindex="0"
                href="javascript:void(0);"
                role="button"
                v-custom-popover="{ content: sanitizeMarkup(tagsTooltip) }"
            >
                <i class="fas fa-info-circle text-primary font-size-xs"></i>
            </a>
        </label>
        <TagsInput
            :data="patientTags"
            :tags="selectedTags"
            v-on:updateTags="updateTags"
            placeholder="Start Typing......"
            :open-on-focus="true"
        />
    </div>
</template>

<script lang="ts" src="./PatientTags.ts"></script>
